import { useState } from 'react';
import { publicLeadsService } from '../../services/api';

const inputCls =
  'w-full px-4 py-3 text-sm bg-white border border-[#141414]/10 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#141414]/30 placeholder:text-[#8A8578]/70';

export default function ContactSection() {
  const [form, setForm] = useState({ name: '', phone: '', email: '', message: '' });
  const [status, setStatus] = useState<'idle' | 'sending' | 'sent'>('idle');
  const [error, setError] = useState('');

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    const phone = form.phone.trim();
    const email = form.email.trim();
    if (!phone && !email) {
      setError('Déjanos tu WhatsApp o correo para poder contactarte.');
      return;
    }
    if (email && !/^\S+@\S+\.\S+$/.test(email)) {
      setError('Ese correo no se ve bien. ¿Lo revisas?');
      return;
    }
    setStatus('sending');
    try {
      await publicLeadsService.submit({
        name: form.name.trim(),
        phone,
        email,
        message: form.message.trim(),
      });
      setStatus('sent');
    } catch {
      setStatus('idle');
      setError('No se pudo enviar. Intenta de nuevo en un momento.');
    }
  };

  return (
    <section id="contacto" className="max-w-6xl mx-auto px-6 py-20 scroll-mt-20">
      <div className="max-w-xl">
        <p className="text-[11px] font-semibold tracking-[0.25em] text-[#8A8578] uppercase">
          Contacto
        </p>
        <h2 className="mt-3 text-3xl sm:text-4xl tracking-tight">
          <span className="font-extrabold text-[#141414]">¿Platicamos? </span>
          <span className="italic font-semibold text-[#8A8578]">Te respondemos el mismo día.</span>
        </h2>

        {status === 'sent' ? (
          <div className="mt-8 bg-white rounded-2xl p-8 shadow-[0_24px_60px_-40px_rgba(20,20,20,0.35)]">
            <p className="font-bold text-[#141414]">¡Listo! Te contactamos pronto.</p>
            <p className="mt-1 text-sm text-[#141414]/65">
              Tu mensaje ya está con nuestro equipo.
            </p>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-8 space-y-3" noValidate>
            <label className="block text-sm font-medium text-[#141414]/80">
              Nombre
              <input
                required
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                className={`mt-1 ${inputCls}`}
                placeholder="¿Cómo te llamas?"
              />
            </label>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <label className="block text-sm font-medium text-[#141414]/80">
                WhatsApp
                <input
                  value={form.phone}
                  onChange={(e) => setForm({ ...form, phone: e.target.value })}
                  className={`mt-1 ${inputCls}`}
                  placeholder="+52 1 55..."
                />
              </label>
              <label className="block text-sm font-medium text-[#141414]/80">
                Correo
                <input
                  type="email"
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  className={`mt-1 ${inputCls}`}
                  placeholder="tu@correo.com"
                />
              </label>
            </div>
            <label className="block text-sm font-medium text-[#141414]/80">
              Mensaje
              <textarea
                rows={3}
                value={form.message}
                onChange={(e) => setForm({ ...form, message: e.target.value })}
                className={`mt-1 ${inputCls} resize-none`}
                placeholder="Cuéntanos de tu inmobiliaria o tus propiedades…"
              />
            </label>
            {error && (
              <p role="alert" className="text-sm text-[#B3261E]">
                {error}
              </p>
            )}
            <button
              type="submit"
              disabled={status === 'sending' || !form.name.trim()}
              className="bg-[#141414] text-white text-sm font-semibold rounded-full px-8 py-3.5 disabled:opacity-40 hover:bg-[#2a2a28] transition-colors"
            >
              {status === 'sending' ? 'Enviando…' : 'Enviar'}
            </button>
          </form>
        )}
      </div>
    </section>
  );
}
